import uScopeApi from 'uScope/js/public-api';
import {VilWrapper} from './VilWrapper';

uScopeApi.plugins.register({
  name: 'vil:wrapper',

  extends: 'uScope',

  constructor: VilWrapper
});



// WEBPACK FOOTER //
// ./src/vil/uScope-extensions/vil-wrapper/index.js